import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Specialists from './pages/Specialists';
import Results from './pages/Results';
import Contact from './pages/Contact';
import Agendar from './pages/Agendar';

// Shared Components
import Navbar from './components/shared/Navbar';
import Footer from './components/shared/Footer';
import ScrollToTop from './components/shared/ScrollToTop';

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col bg-light">
        {/* Scroll global ao topo em mudança de rota */}
        <ScrollToTop behavior="smooth" />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quem-somos" element={<About />} />
          <Route path="/servicos" element={<Services />} />
          <Route path="/services" element={<Specialists />} />
          <Route path="/resultados" element={<Results />} />
          <Route path="/results" element={<Results />} />
          <Route path="/contato" element={<Contact />} />
          {/* Alias em inglês para compatibilidade com links existentes */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/agendar" element={<Agendar />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
